var exports = {
  "U": "x234b8571--811a0e--arrow",
};

module.exports = exports;
